export default __webpack_public_path__ + "static/omar_dancing-5834d3449ca08257d93a615ffbc74b50.png";